"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyMerkleProof = exports.createDummyMerkleProof = void 0;
const circomlibjs_1 = require("circomlibjs");
const merkletree_types_1 = require("../models/merkletree-types");
const bytes_1 = require("../utils/bytes");
const merkletree_1 = require("./merkletree");
const createDummyMerkleProof = (leaf) => {
    const indices = (0, bytes_1.nToHex)(0n, bytes_1.ByteLength.UINT_256);
    const elements = new Array(merkletree_types_1.TREE_DEPTH).fill((0, bytes_1.hexToBigInt)((0, bytes_1.randomHex)(31)));
    let latestHash = (0, bytes_1.hexToBigInt)(leaf);
    for (let level = 0; level < elements.length; level += 1) {
        latestHash = (0, circomlibjs_1.poseidon)([latestHash, elements[level]]);
    }
    return {
        leaf,
        indices,
        elements: elements.map((el) => (0, bytes_1.nToHex)(el, bytes_1.ByteLength.UINT_256)),
        root: (0, bytes_1.nToHex)(latestHash, bytes_1.ByteLength.UINT_256),
    };
};
exports.createDummyMerkleProof = createDummyMerkleProof;
/**
 * Verifies a merkle proof
 * @param proof - proof to verify
 * @returns is valid
 */
const verifyMerkleProof = (proof) => {
    // Get indices as BN form
    const indices = (0, bytes_1.numberify)(proof.indices);
    // Calculate proof root and return if it matches the proof in the MerkleProof
    // Loop through each element and hash till we've reduced to 1 element
    const calculatedRoot = proof.elements.reduce((current, element, index) => {
        // If index is right
        if (indices.testn(index)) {
            return merkletree_1.Merkletree.hashLeftRight(element, current);
        }
        // If index is left
        return merkletree_1.Merkletree.hashLeftRight(current, element);
    }, proof.leaf);
    return (0, bytes_1.hexlify)(proof.root) === (0, bytes_1.hexlify)(calculatedRoot);
};
exports.verifyMerkleProof = verifyMerkleProof;
